import React from 'react'
import { Box } from 'grommet'

const HorizontalLine = ({ color = 'darkTint', height = '1px' }) => {
  return <Box height={height} background={color} />
}

export default HorizontalLine
